export const LOCALSTORAGEAUTHUSERINFO = "mortgage-basket-auth-user-info";
export const LOCALSTORAGEREFERENCEDATA = "mortgage-basket-reference-data";
export const LOCALSTORAGELENDERREFERENCEDATA = "lender-reference-data";
export const LOCALSTORAGEUSERLOGGEDINTIME =
  "mortgage-basket-user-logged-in-time";
export const LOCALSTORAGEREMEMBERMEUSER = "mortgage-basket-remember-me-user";
